import { useCallback } from "react"

import { useDispatch } from "react-redux"

import type { IAppDispatch } from "@/3514/store"
import type { TEmptyCallback } from "@/shared/types/functions"

import {
    type IParticipantHeaderState as IState,
    participantHeaderReducerActions as actions
} from "./participant.header.slice"

type TParticipantHeaderDispatcher = {
    setConfig(config: Pick<IState, "config">["config"]): void
    setExcerpts(excerpts: Pick<IState, "excerpts">["excerpts"]): void
    resetState: TEmptyCallback
}

function useParticipantHeaderDispatcher(): ReturnType<() => TParticipantHeaderDispatcher> {
    const dispatch: IAppDispatch = useDispatch<IAppDispatch>()

    const setConfig: (config: Pick<IState, "config">["config"]) => void = useCallback(
        (config: Pick<IState, "config">["config"]): void => void dispatch(actions.configSetter(config)),
        [dispatch]
    )

    const setExcerpts: (excerpts: Pick<IState, "excerpts">["excerpts"]) => void = useCallback(
        (excerpts: Pick<IState, "excerpts">["excerpts"]): void => void dispatch(actions.excerptsSetter(excerpts)),
        [dispatch]
    )

    const resetState: TEmptyCallback = useCallback((): void => void dispatch(actions.resetState(void 0)), [dispatch])

    return { setConfig, setExcerpts, resetState }
}

export { useParticipantHeaderDispatcher, type TParticipantHeaderDispatcher }
